import React from "react"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import dayjs from "dayjs"

export const UserInteractionForm = ({ startDate, endDate, onStartChange, onEndChange }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="flex flex-col gap-2 mt-1 w-fit">
        <DatePicker
          label="From"
          value={startDate}
          onChange={onStartChange}
          minDate={dayjs("2018-01-01")}
          maxDate={endDate}
          slotProps={{ textField: { size: "small" } }}
        />
        <DatePicker
          label="To"
          value={endDate}
          onChange={onEndChange}
          minDate={startDate}
          maxDate={dayjs().subtract(1, "day")}
          slotProps={{ textField: { size: "small" } }}
        />
      </div>
    </LocalizationProvider>
  )
}
